<!-- desktop -->
<div *ngIf="!mobileService.isMobile" class="headline">
  <div class="headline-container" [class.mobile]="mobileService.isMobile" fxLayout="row" fxLayoutGap="10px">
    <!-- TODO add passing heading tags h1, p etc -->
    <div class="headline-text">
      {{ headlineText }}
    </div>
    <div class="headline-description">
      {{ headlineDescription }}
    </div>
  </div>
</div>

<!-- mobile -->
<div *ngIf="mobileService.isMobile" class="headline-mobile">
  <div class="headline-container" fxLayout="row" fxLayoutGap="10px">
    <div class="headline-text"><span [innerHTML]="boldFirstWord(headlineText)"></span> {{ headlineDescription }}</div>
  </div>
</div>
